import {
    ActionType,
    getDetectionListAction
} from "./actions";
import { DetectionJson } from "../../../domain/detection/Detection";
import { createSlice } from "@reduxjs/toolkit";

export type DetectionState = Readonly<{
    detections: DetectionJson[] | null
}>

const detectionInitialState: DetectionState = {
    detections: null
};

const slice = createSlice({
    name: ActionType.base,
    initialState: detectionInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getDetectionListAction.pending,
                (state) => {
                    state.detections = null;
                }
            )
            .addCase(
                getDetectionListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { detections } = payload;
                    state.detections = detections;
                }
            )
            .addCase(
                getDetectionListAction.rejected,
                (state) => {
                    state.detections = [];
                }
            );
    }
});

export const detectionReducer = slice.reducer; 
